// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textOverflow[data-v-198738ee] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.textOverflow .linkSpan[data-v-198738ee] {\n  cursor: pointer;\n  color: #1890FF;\n}\n.textOverflow .linkSpan[data-v-198738ee]:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
